export default __webpack_public_path__ + "static/media/treesFooter.14ba2fb0.png";